import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton as MuiSkeleton } from '@mui/material';
const Skeleton = ({ fullWidth, width, height, ...props }) => {
    const skeletonHeight = height === 'input' ? 36 : height === 'inputSmall' ? 24 : height === 'emptyAutocomplete' ? 41 : height;
    return _jsx(MuiSkeleton, { ...props, width: fullWidth ? '100%' : width, height: skeletonHeight });
};
export { Skeleton };
